import React from 'react';
import { Button, Typography } from '@material-ui/core';

function StripePaymentForm({
  amountLabel,
  disabled,
  loading,
  error,
  onPay,
  classes,
}) {
  return (
    <div>
      <Typography className={classes.stripeHint}>
        Serás redirigido a Stripe para completar el pago de forma segura. Ahí
        también podrás ingresar un código de promoción.
      </Typography>
      {error && <p className={classes.errorText}>{error}</p>}
      <Button
        variant="contained"
        color="primary"
        className={classes.payButton}
        disabled={disabled || loading}
        onClick={onPay}
      >
        {loading ? 'Redirigiendo a Stripe...' : `Pagar ${amountLabel} con Stripe`}
      </Button>
    </div>
  );
}

export default StripePaymentForm;
